import {ERROR_OCCURRED} from '../constants/actionTypes';

export const errorOccurred = (error)=>{
  return {type:ERROR_OCCURRED,error};
};
